import React, { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import ScrollReveal from "scrollreveal";
import "./BBYears.css"; 


const BBYears = () => {
    useEffect(() => {
        const sr = ScrollReveal({
          reset: false,  // Keep the items visible once revealed
          distance: '300px',  // Distance the element will move as it comes into view
          duration: 700,  // Duration of 1.5 seconds for each item reveal
          easing: 'ease-in-out',  // Smooth easing function
          interval: 200,  // Interval between the reveal of each item
          delay: 200, // Delay before starting each reveal (for smoother staggered effect)
        });
      
        const timelineItems = document.querySelectorAll(".timeline-item");
        timelineItems.forEach((el, index) => {
          const contentElement = el.querySelector(".timeline-content");
      
          // Apply alternating direction based on index
          if (index % 2 === 0) {
            contentElement.classList.add("js--fadeInLeft");
            sr.reveal(contentElement, {
              origin: "left",  // Slide in from the left
              delay: 100 * index,  // Staggered reveal based on index
            });
          } else {
            contentElement.classList.add("js--fadeInRight");
            sr.reveal(contentElement, {
              origin: "right",  // Slide in from the right
              delay: 100 * index,  // Staggered reveal based on index
            });
          }
        });
      
      }, []);
      
    return (


        <div className="bb-years">
            <h1 className='headings text-center mt-4'><span>Milestone </span>Achieved</h1>
            <div className="container">
                <div className="row">
                    <section className="timeline">
                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInLeft">
                                <div className="box-2013 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2013</h1>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Djibouti</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInRight">
                                <div className="box-2014 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2014</h1>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Namibia</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - India</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInLeft">
                                <div className="box-2015 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2015</h1>
                                        <div className="d-flex"> 
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Dubai</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Madagascar</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInRight">
                                <div className="box-2016 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2016</h1>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Zimbabwe</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInRight">
                                <div className="box-2017 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2017</h1>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Malawi</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Congo</p>
                                        </div>
                                        <div className="d-flex"> 
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Zambia</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInRight">
                                <div className="box-2018 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2018</h1>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location'  loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Mozambique</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location'  loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - C.A.R</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Nigeria</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Jaipur, India</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Kinshasa</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>




                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInRight">
                                <div className="box-2019 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2019</h1>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Kenya</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location'loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Angola</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Ivory Coast</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Uganda</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInRight">
                                <div className="box-2020 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2021</h1>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location'  loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Cameroon</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInRight">
                                <div className="box-2018 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2022</h1>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy"  />
                                            <p className='location-name'>Blueberry Travel - Yaoundé</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location'  loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Togo</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location'  loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Tanzania</p>
                                        </div>
                                        {/* <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location'  loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Botswana</p>
                                        </div> */}
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location'  loading="lazy" />
                                            <p className='location-name'>Blueberry Tour & Travel Services - Cameroon</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location'  loading="lazy" />
                                            <p className='location-name'>Blueberry Voyage Pvt. Ltd. - Tanzania</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInRight">
                                <div className="box-2024 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2023</h1>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Ghana</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Voyage Services - Gabon</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Visa Services Accra - Ghana</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Visa Services - Cameroon</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location'  loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Botswana</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Gurgaon, India</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - South Africa</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="timeline-item">
                            <div className="timeline-img"></div>
                            <div className="timeline-content js--fadeInRight">
                                <div className="box-2018 box-mobile">
                                    <div className="year-number">
                                        <h1 className='headings'>2024</h1>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Travels - Senegal</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Friends Travel & Tourism L.L.C - CAR
                                            </p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Friends Travel & Tourism L.L.C - Kenya</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Algeria</p>
                                        </div>
                                        <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Blueberry Travel - Burkina Faso</p>
                                        </div>
                                        {/* <div className="d-flex">
                                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/bblocation.svg" alt="" className='bb-location' loading="lazy" />
                                            <p className='location-name'>Next Holidays - India</p>
                                        </div> */}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
            </div>
        </div>
    );

};

export default BBYears;
